import {NavigationBackground, SkinTheme, UIType} from "../@const";
import {GoodDayUserInterface} from "../ui";
import NavigationPanel_UserAsana from "./navigation-panel/user-asana";
import UI_Layout from "../../layout/ui-layout";
import UI_TopPanel_Asana from "./top/ui-top";
import PaletteProto from "../../../core/gd/skin/skin-palette/palette-proto";
import CommonPaletteAsana from "./common-palette-asana";
import GrayPalette_Asana from "./gray-palette-asana";

export class UIAsana extends GoodDayUserInterface {

    constructor() {
        super({
            type        : UIType.ASANA
        })
    }

    get layoutCSSClass():string {
        return "ui-layout ui-layout-asana left-nav"
    }

    get isMinimizeMenuAllowed(): boolean {
        return false
    }

    get TopPanel():any {
        return UI_TopPanel_Asana
    }

    get LayoutClass() {
        return UI_Layout
    }

    get NavigationPanelUserComponent() {
        return NavigationPanel_UserAsana
    }

    get leftNavigationPanelSize(): number {
        return 64
    }

    get uiLeftMenuThemeClass() {

        return "ui-left-theme-asana"
    }

    get navbarButtonSize() {
        return 64
    }

    get uiCenterLeftSideDifference(): number {
        return 64 // +0
    }

    get navigationPanelMainClass() {

        return "ui-navigation left-nav navigation-theme-asana"
    }

    getCommonPalette(theme: SkinTheme): PaletteProto {
        return new CommonPaletteAsana(theme);
    }

    getGrayPalette(theme: SkinTheme): PaletteProto {
        return new GrayPalette_Asana(theme)
    }

    get uiCenterMainClass() {
        return 'ui-center-asana'
    }

    get moreLabel(): string {
        return "More"
    }
}
